import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {FreeSpinsEvents} from '@fantasmagames/slot/src/modules/freespins/intro/FreeSpinsEvents';
import {FreeSpinsModule} from '@fantasmagames/slot/src/modules/freespins/intro/FreeSpinsModule';
import {FreeSpinsView} from '@fantasmagames/slot/src/modules/freespins/intro/FreeSpinsView';
import {ReelsEvents} from '@fantasmagames/slot/src/modules/reels/spin/ReelsEvents';
import {AvalancheReelsEvents} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsEvents';

export class FreeSpinsIntroState extends ModuleState<FreeSpinsView, FreeSpinsModule> {
	protected _inputFunction: EventListenerObject;

	public onEnterState(): void {
		this.view.setFreeSpinsAmount(this.module.logic.freeSpinsLeft);
		this.emit(FreeSpinsEvents.FREE_SPINS_INTRO_STARTED);
	}

	public onLeaveState(): void {
		this.removeKeyboardInput();
	}

	protected setupEvents(): void {
		this.on(FreeSpinsView.FREE_SPINS_INFO_CONTINUE_CLICKED, this.onFreeSpinsIntroContinueClicked);
		this.on(FreeSpinsView.FREE_SPINS_INTRO_FINISHED, this.onFreeSpinsIntroFinished);
		this.on(ReelsEvents.REELS_FADING_OUT_FINISHED, this.onReelsFadingOutFinished);
		this.on(AvalancheReelsEvents.REELS_FADING_OUT_FINISHED, this.onReelsFadingOutFinished);
	}

	protected onFreeSpinsIntroContinueClicked(): void {
		this.removeKeyboardInput();

		this.module.gotoState(FreeSpinsModule.IN_PROGRESS_STATE);
		this.view.endFreeSpinsIntro();
	}

	protected onReelsFadingOutFinished(): void {
		this.startFreeSpinsIntroAnimation();
	}

	protected startFreeSpinsIntroAnimation(): void {
		this.view.startFreeSpinsIntro();
	}

	protected keyboardInput(event: KeyboardEvent): void {
		if (this.view.isVisible()) {
			if (event.code === 'Space' || event.code === 'Enter') {
				this.proceed();
			}

			if (event.code === 'KeyA' || event.code === 'ArrowLeft') {
				this.view.gotoPreviousFeature();
			}

			if (event.code === 'KeyD' || event.code === 'ArrowRight') {
				this.view.gotoNextFeature();
			}
		}
	}

	protected proceed(): void {
		this.removeKeyboardInput();
		this.view.proceed();
		// this.module.gotoState(FreeSpinsModule.IN_PROGRESS_STATE);
	}

	protected addKeyboardInput(): void {
		if (!this.module.device.isMobile) {
			this._inputFunction = this.keyboardInput.bind(this);
			document.addEventListener('keydown', this._inputFunction);
		}
	}

	protected removeKeyboardInput(): void {
		document.removeEventListener('keydown', this._inputFunction);
	}

	protected onFreeSpinsIntroFinished(): void {
		this.addKeyboardInput();
		this.emit(FreeSpinsEvents.FREE_SPINS_START_READY);
		this.view.enablePlayButton();
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/freespins/intro/states/FreeSpinsIntroState.ts